<!-- 编辑套包设置 -->
<template>
    <div class="business-content-main">
        <div style="margin-right: 80px">
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="section-title" style="margin-top: 22px">
                <div>
                    <el-button v-if="type == 0 || (type == 2 && orderState == 0)" size="small" class="btn-primary search-btn" @click="submitForm('0')">保存组装单</el-button>
                    <el-button v-if="type == 0 || type == 2 || type == 4" size="small" class="btn-primary search-btn" @click="submitForm('1')">提交组装单</el-button>
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="setPack(0)" v-if="permission.pack && orderState == 1 && type == 3">整单组装</el-button>
                </div>
            </div>
            <div class="search-ctn" style="padding-top: 22px">
                <el-form :model="submitData" ref="formMsg" label-width="100px" :rules="rules" style="width: 100%; padding-right: 30px">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content">
                                <el-form-item label="组装单号">
                                    <el-input style="width: 100%" disabled v-model="submitData.SetOrderCode" :title="submitData.SetOrderCode"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content">
                                <el-form-item label="组装仓库" prop="SId">
                                    <el-select
                                        v-model="submitData.SId"
                                        :disabled="dataReadonly || type == 4"
                                        placeholder="请选择"
                                        style="width: 100%"
                                        filterable
                                        clearable
                                        @visible-change="warehouseVisibleChange($event)"
                                        @change="warehouseChange"
                                    >
                                        <el-option
                                            v-for="optionItem in warehouseList"
                                            v-bind:key="optionItem.index"
                                            :label="optionItem.WarehouseName"
                                            :value="optionItem.WarehouseId"
                                        >
                                            <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content">
                                <el-form-item label="期限时间" prop="NeedTime">
                                    <el-date-picker
                                        style="width: 100%"
                                        value-format="yyyy-MM-dd"
                                        v-model="submitData.NeedTime"
                                        :disabled="dataReadonly"
                                        :picker-options="expireTimeOption"
                                        type="date"
                                    ></el-date-picker>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="grid-content">
                                <el-form-item label="备注" prop="OrderSale">
                                    <el-input style="width: 100%" :disabled="dataReadonly" v-model="submitData.Remark" :title="submitData.Remark"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!--    table    -->
            <div class="section-title">
                <div>
                    套包商品
                    <span v-if="type == 4" style="font-size: 14px; margin-left: 10px; color: red"
                        >（ 温馨提醒：已组装的商品不能再进行修改！部分组装的商品数量可修改，但不能少于已组装数！ ）</span
                    >
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearch(false)" v-if="!dataReadonly">搜索套包商品</el-button>
                </div>
            </div>
            <div class="edit-ctn">
                <!--      table title      -->
                <div @click="hideMsg()" class="div-table-row table-title">
                    <div class="div-table-cell" style="width: 15%; flex-grow: 1"><span class="color-red">*</span>套包编码</div>
                    <div class="div-table-cell" style="width: 20%"><span class="color-red">*</span>套包名称</div>
                    <div class="div-table-cell" style="width: 25%">适用车型</div>
                    <div class="div-table-cell" style="width: 10%">单位</div>
                    <div class="div-table-cell" style="width: 10%">当前库存</div>
                    <div class="div-table-cell" style="width: 10%">需组装数量</div>
                    <div class="div-table-cell" style="width: 5%" v-if="type == 3">已组数量</div>
                    <div class="div-table-cell" style="width: 5%" v-if="type == 3">操作</div>
                    <div class="div-table-cell" style="width: 5%" v-if="type == 4">状态</div>
                </div>
            </div>
        </div>
        <!-- table body -->
        <div
            id="infinite-list"
            class="infinite-list"
            :style="{ height: infiniteListHeight + 'px' }"
            v-infinite-scroll="loadDownScroll"
            infinite-scroll-distance="10"
            :infinite-scroll-immediate="false"
        >
            <div class="edit-ctn">
                <div @click="hideMsg()" class="table-main">
                    <div v-for="(item, index) in dataList" :key="index" style="margin-right: 80px">
                        <div v-if="index >= startIdx && index <= endIdx" class="div-table-row table-item" :ref="'pj' + index">
                            <!--        编码            -->
                            <div class="div-table-cell div-table-cell-code" style="width: 15%; flex-grow: 1" :class="{ 'check-code-class': item.CodeRepeat }">
                                <img src="../../../assets/images/info.png" alt title="套包商品信息" class="info-icon" @click="setPack(2, item)" />
                                <el-select
                                    style="width: 100%"
                                    :ref="'code' + index"
                                    :disabled="dataReadonly || item.PackedCount > 0"
                                    default-first-option
                                    size="small"
                                    v-model="item.APCode"
                                    value-key="APCode"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    placeholder="套包商品信息"
                                    @focus="hideMsg"
                                    @change="codeChange($event, index)"
                                    @visible-change="apCodeVisibleChange($event)"
                                    :remote-method="searchCode"
                                    v-select-scroll-more="searchCodeLoad"
                                >
                                    <el-option
                                        v-for="optionItem in codeList"
                                        v-bind:key="optionItem.index"
                                        :data-msg="optionItem"
                                        :label="optionItem.APCode"
                                        :value="optionItem.APCode"
                                    >
                                        <div class="option-content">
                                            <div style="width: 200px">{{ optionItem.APCode }}</div>
                                            <div style="width: 200px">{{ optionItem.GoodName }}</div>
                                            <div style="width: 200px">{{ optionItem.AutoSerise }}</div>
                                        </div>
                                    </el-option>
                                    <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                                </el-select>
                                <div v-if="item.State == 1" class="row-delete">已删除</div>
                            </div>
                            <!--        名称            -->
                            <div class="div-table-cell" style="width: 20%">
                                <el-select
                                    style="width: 100%"
                                    :disabled="dataReadonly || item.PackedCount > 0"
                                    size="small"
                                    v-model="item.GoodName"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    placeholder="套包商品名称"
                                    @focus="hideMsg"
                                    @change="nameChange($event, index)"
                                    @visible-change="apNameVisibleChange($event)"
                                    :remote-method="searchName"
                                    v-select-scroll-more="searchNameLoad"
                                >
                                    <el-option
                                        v-for="optionItem in nameList"
                                        :data-msg="optionItem"
                                        :label="optionItem.GoodName"
                                        :value="optionItem.GoodName"
                                        v-bind:key="optionItem.index"
                                    >
                                        <div class="option-content">
                                            <div style="width: 200px">{{ optionItem.GoodName }}</div>
                                            <div style="width: 200px">{{ optionItem.APCode }}</div>
                                            <div style="width: 200px">{{ optionItem.AutoSerise }}</div>
                                        </div>
                                    </el-option>
                                    <el-option v-if="loading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                                </el-select>
                            </div>
                            <!--        车系            -->
                            <div class="div-table-cell" style="width: 25%">
                                {{ item.AutoSerise }}
                            </div>
                            <!--        单位         -->
                            <div class="div-table-cell" style="width: 10%">
                                {{ item.Unit }}
                            </div>
                            <div class="div-table-cell" style="width: 10%">
                                {{ item.Inventory }}
                            </div>
                            <!--        数量            -->
                            <div class="div-table-cell" style="width: 10%">
                                <el-input-number
                                    type="number"
                                    :ref="'count' + index"
                                    :min="item.PackedCount > 0 ? item.PackedCount : 1"
                                    :precision="0"
                                    size="small"
                                    v-model="item.Count"
                                    @change="priceChange"
                                    @focus="hideMsg"
                                    :disabled="dataReadonly || item.IsPacked"
                                ></el-input-number>
                            </div>
                            <div class="div-table-cell" style="width: 5%" v-if="type == 3">
                                {{ item.PackedCount }}
                            </div>
                            <div class="div-table-cell" style="width: 5%" v-if="type == 3">
                                <el-button
                                    @click="setPack(1, item)"
                                    size="mini"
                                    class="search-btn btn-primary"
                                    style="margin-left: 0"
                                    v-if="permission.pack && type == 3 && item.Count - item.PackedCount > 0 && item.PackedCount == 0"
                                    >{{ permission.pack }}</el-button
                                >
                                <el-button
                                    @click="setPack(1, item)"
                                    size="mini"
                                    class="search-btn btn-primary"
                                    style="margin-left: 0"
                                    v-else-if="permission.pack && type == 3 && item.Count - item.PackedCount > 0 && item.PackedCount != 0"
                                    >部分组装</el-button
                                >
                                <span v-if="item.Count == item.PackedCount">
                                    <el-tooltip effect="dark" content="已组装" placement="top">
                                        <span>已组装</span>
                                    </el-tooltip>
                                </span>
                            </div>
                            <div class="div-table-cell" style="width: 5%" v-if="type == 4">
                                {{ item.PackedCount == 0 ? '未组装' : item.Count == item.PackedCount ? '已组装' : '部分组装' }}
                            </div>
                            <el-button class="less-btn" icon="el-icon-minus" circle @click="delItem(index)" v-if="!dataReadonly && item.PackedCount == 0"></el-button>
                        </div>
                    </div>
                    <div class="infinite-loading" v-if="showInfiniteLoading"><i class="el-icon-loading" />加载中</div>
                    <div style="margin-right: 80px" v-else>
                        <div class="div-table-row table-item">
                            <div class="div-table-cell" style="width: 15%; flex-grow: 1"></div>
                            <div class="div-table-cell" style="width: 20%"></div>
                            <div class="div-table-cell" style="width: 25%"></div>
                            <div class="div-table-cell" style="width: 10%"></div>
                            <div class="div-table-cell" style="width: 10%">总数量</div>
                            <div class="div-table-cell" style="width: 10%">
                                <el-tooltip effect="dark" :content="allNum.toString()" placement="top">
                                    <span>{{ allNum }}</span>
                                </el-tooltip>
                            </div>
                            <div class="div-table-cell" style="width: 5%" v-if="type == 3"></div>
                            <div class="div-table-cell" style="width: 5%" v-if="type == 3"></div>
                            <div class="div-table-cell" style="width: 5%" v-if="type == 4"></div>
                        </div>
                        <el-button class="add-btn" type="primary" icon="el-icon-plus" circle @click="addItem()" v-if="!dataReadonly"></el-button>
                    </div>
                </div>
            </div>
        </div>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索套包商品" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchSetAP priceType="1" canEdit="canNot" :OnlyOneOption="false" :IsOnlySets="true" @closeDialog="closeSearchDialog"></searchSetAP>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="setPackVisible" width="1200px">
            <div v-if="setPackVisible">
                <setPackDetails
                    :SId="submitData.SId"
                    :WarehouseName="warehouseName"
                    :SetId="setId"
                    :PType="pType"
                    :MaxCount="maxCount"
                    :SetOrderId="setOrderId"
                    @closeDialog="closeSetPackDialog"
                ></setPackDetails>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import searchSetAP from '@/components/common/searchAP';
import setPackDetails from '@/components/business/goods/setPackDetails';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        searchSetAP,
        breadcrumb,
        setPackDetails
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.init();
            }
        },
        showSetMsg() {
            let topValue = document.getElementById('infinite-list').scrollTop;
            this.scrollPosition = topValue;
        }
    },
    data() {
        return {
            needConfirm: true,
            pType: 0,
            maxCount: 0,
            title: '',
            setPackVisible: false,
            setId: '',
            orderState: 0,
            setOrderId: '',
            setModel: {},
            EntpTempGoodsIdEdit: '',
            loading: false,
            dataReadonly: false,
            showSetMsg: true,
            searchVisible: false,
            allNum: 1,
            editIndex: -1,
            warehouseName: '',
            submitData: {
                SetOrderCode: '',
                NeedTime: new Date(),
                Remark: '',
                SId: '',
                SetOrderId: '',
                SubmissionState: '',
                DetailList: []
            },
            Limit: 10,
            codeList: [],
            nameList: [],
            dataList: [],
            warehouseList: [],
            type: 0, // 0 新增 1 查看 2 编辑 3组装 4修改
            id: '',
            pageTitle: '',
            startIdx: 0, // 列表显示的第一个列的下标
            endIdx: 49, // 列表显示的最后一个列的下标
            stopLoad: false, // 停止监听上下滚动
            windowHeight: window.innerHeight,
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            scrollPosition: 0, // 滚动条位置，用于判断是否收起信息栏
            rules: {
                SId: [
                    {
                        required: true,
                        message: '该项必选',
                        trigger: 'blur'
                    }
                ],
                NeedTime: [
                    {
                        required: true,
                        message: '该项必填',
                        trigger: 'blur'
                    }
                ]
            },
            expireTimeOption: {
                disabledDate(date) {
                    return date.getTime() <= Date.now() - 86400000;
                }
            },
            permission: {},
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于配件名称列表，分页搜索功能
            nameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    mounted() {
        this.init();
        // 监听滚动事件
        document.addEventListener('scroll', this.loadTopScroll, true);
        window.onresize = () => {
            this.resetHeight();
        };
        // 给business-content强行写入css样式
        let bc = document.getElementsByClassName('business-content')[0];
        bc.style.overflow = 'hidden';
        bc.style.scrollbarWidth = 'none';

        this.permission = this.$util.getPermission('SetOrderManage');
    },
    destroyed() {
        document.removeEventListener('scroll', this.loadTopScroll, true);
        let bc = document.getElementsByClassName('business-content')[0];
        bc.style.overflow = 'auto';
        bc.style.scrollbarWidth = 'auto';
    },
    computed: {
        // 是否显示loading
        showInfiniteLoading() {
            return this.endIdx < this.dataList.length - 1;
        }
    },
    methods: {
        /**
         * 向上滚动
         * topValue: 距离顶部距离
         */
        loadTopScroll() {
            let topValue = document.getElementById('infinite-list').scrollTop;
            if (this.showSetMsg && topValue > this.scrollPosition) {
                this.scrollPosition = topValue;
                this.hideMsg();
            }
            if (topValue > 150 || this.stopLoad) return;
            this.stopLoad = true;
            if (this.startIdx > 0) {
                if (this.startIdx < 25) {
                    let over = this.startIdx;
                    this.startIdx -= Math.abs(over);
                    this.endIdx -= Math.abs(over);
                    this.$message({
                        type: 'info',
                        offset: this.windowHeight / 2,
                        message: '您现在在顶部'
                    });
                } else if (this.startIdx >= 25) {
                    this.startIdx -= 25;
                    this.endIdx -= 25;
                    if (this.startIdx === 0) {
                        this.$message({
                            type: 'info',
                            offset: this.windowHeight / 2,
                            message: '您现在在顶部'
                        });
                    } else {
                        // 对火狐浏览器做特殊处理
                        if (navigator.userAgent.indexOf('Firefox') >= 0) {
                            let sh = document.getElementById('infinite-list').scrollHeight / 4;
                            document.getElementById('infinite-list').scrollTop = sh;
                        }
                    }
                }
            }
            this.stopLoad = false;
        },
        // 向下滚动
        loadDownScroll() {
            let listLastIndex = this.dataList.length - 1;
            if (listLastIndex < 50 || this.stopLoad) return;
            this.stopLoad = true;
            if (this.endIdx < listLastIndex) {
                if (this.endIdx + 25 <= listLastIndex) {
                    this.startIdx += 25;
                    this.endIdx += 25;
                    if (this.endIdx === this.listLastIndex) {
                        this.$message({
                            type: 'info',
                            offset: this.windowHeight / 2,
                            message: '您已经触底了哦~'
                        });
                    }
                } else {
                    let over = this.endIdx;
                    this.startIdx += listLastIndex - over;
                    this.endIdx += listLastIndex - over;
                    this.$message({
                        type: 'info',
                        offset: this.windowHeight / 2,
                        message: '您已经触底了哦~'
                    });
                }
            }
            this.stopLoad = false;
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        init() {
            this.getWarehouse();
            let fullPath = this.$route.fullPath;
            document.onkeydown = event => {
                if (fullPath == this.$route.fullPath && this.type != 1) {
                    let e = event || window.event || arguments.callee.caller.arguments[0];
                    if (e && e.keyCode == 13) this.addItem();
                }
            };

            this.setOrderId = this.$route.query.SetOrderId;
            this.type = Number(this.$route.query.type);

            switch (this.type) {
                case 3:
                    this.pageTitle = '组装单出仓';
                    this.dataReadonly = true;
                    this.getSetOrderDetail();
                    break;
                case 1:
                    this.pageTitle = '查看组装单详细';
                    this.dataReadonly = true;
                    this.needConfirm = false;
                    this.getSetOrderDetail();
                    break;
                case 2:
                    this.pageTitle = '编辑组装单';
                    this.dataReadonly = false;
                    this.getSetOrderDetail();
                    break;
                case 0:
                    this.pageTitle = '新增组装单';
                    this.addItem();
                    // this.getdefaultWarehouses();
                    break;
                case 4:
                    this.pageTitle = '修改组装单';
                    this.dataReadonly = false;
                    this.getSetOrderDetail();
                    break;
                default:
                    break;
            }
            setTimeout(() => {
                this.resetHeight();
            }, 0);
        },
        getConfigData() {
            this.$util.getConfigData('Unit').then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            this.searchVisible = true;
        },
        closeSearchDialog(items) {
            let itemList = [...items];
            let tempList = [];
            if (this.dataList[0].APCode != '') {
                tempList = tempList.concat(this.dataList);
            }

            for (let i = 0; i < itemList.length; i++) {
                const item = itemList[i];
                let isConcat = false;
                for (let j = 0; j < this.dataList.length; j++) {
                    const element = this.dataList[j];
                    if (element.APCode == item.APCode) {
                        isConcat = true;
                        j = this.dataList.length;
                    }
                }

                if (!isConcat) {
                    let _data = {
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        SetId: item.SetId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        Count: 1,
                        PackedCount: 0,
                        Unit: item.Unit,
                        CodeRepeat: false,
                        Inventory: item.Inventory,
                        State: 0,
                        IsPacked: false
                    };
                    tempList.push(_data);
                }
            }
            this.dataList = tempList;
            this.checkCodeRepeat();

            this.priceChange();
            this.searchVisible = false;
        },
        // 配件信息
        hideMsg() {
            this.showSetMsg = false;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        showMsg() {
            this.showSetMsg = true;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        checkCodeRepeat() {
            let repeatIndexs = [];
            let obj = {};
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                _dataList[i].CodeRepeat = false;
                if (!obj[_dataList[i].APCode]) {
                    obj[_dataList[i].APCode] = [i];
                } else {
                    obj[_dataList[i].APCode].push(i);
                }
            }

            for (let key in obj) {
                if (obj[key].length >= 2 || this.submitData.APCode == key) {
                    repeatIndexs = [...repeatIndexs, ...obj[key]];
                }
            }
            for (let j = 0; j < repeatIndexs.length; j++) {
                this.dataList[repeatIndexs[j]].CodeRepeat = true;
            }
        },
        // 获取详情
        getSetOrderDetail() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEnterpriseSetOrderDetails',
                    data: {
                        SetOrderId: that.setOrderId
                    }
                })
                .then(res => {
                    let data = res.data;
                    // if (data.Warehouse) {
                    //     that.warehouseList.push({
                    //         WarehouseId: data.Warehouse.WarehouseId,
                    //         WarehouseName: data.Warehouse.WarehouseName
                    //     });
                    //     that.warehouseName = data.Warehouse.WarehouseName;
                    // } else {
                    //     that.getdefaultWarehouses();
                    // }

                    let DetailList = data.DetailList;
                    that.submitData = data;
                    that.orderState = data.State;
                    let _allNum = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        that.allNum = _allNum;
                        that.dataList = DetailList;
                    }
                });
        },
        // 提交组装单
        submitForm(submissionState) {
            this.$refs['formMsg'].validate(valid => {
                let that = this;
                if (valid) {
                    let _dataList = that.dataList;
                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            that.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            that.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (!_dataList[i].Count || _dataList[i].Count < 0) {
                            that.$util.warningMsg('请填写正确的数量');
                            return;
                        } else {
                            if (_dataList[i].PackedCount > 0 && _dataList[i].Count < _dataList[i].PackedCount) {
                                that.$util.warningMsg('商品数量不能少于已组装数，已组装' + _dataList[i].PackedCount + '个商品');
                                return;
                            }
                        }
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                            return;
                        }
                    }
                    that.submitData.DetailList = _dataList;
                    that.submitData.SubmissionState = submissionState;
                    that.submit();
                }
            });
        },
        submit() {
            let that = this;
            that.submitData.SetOrderId = that.setOrderId;
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/SaveEnterpriseSetOrders',
                    data: that.submitData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        let name = '';
                        switch (that.submitData.SubmissionState) {
                            case 0:
                                name = '保存';
                                break;
                            case 1:
                                name = '提交';
                                break;
                        }
                        that.$util.successMsg(name + '组装单成功');

                        // //添加默认出仓仓库
                        // if (that.submitData.SId) {
                        //     let defaultWarehouses = that.$util.getLocalStorage('defaultSetOrderWarehouses');
                        //     if (defaultWarehouses) {
                        //         for (let i = 0; i < defaultWarehouses.length; i++) {
                        //                 defaultWarehouses.splice(i, 1);
                        //                 break;
                        //         }
                        //     } else {
                        //         defaultWarehouses = [];
                        //     }
                        //     defaultWarehouses.push({
                        //         WarehouseId: that.submitData.SId,
                        //         WarehouseName: that.warehouseName
                        //     });

                        //     that.$util.setLocalStorage('defaultSetOrderWarehouses', defaultWarehouses);
                        // }
                        that.needConfirm = false;
                        that.$store.commit('updateNeedRefresh', true);
                        setTimeout(() => {
                            that.$router.push('/inventoryManage/goods/setOrders');
                        }, 2000);
                    }
                });
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.priceChange();
        },
        // 添加一行
        addItem() {
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
            }

            this.dataList.push({
                Inventory: 0,
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                Count: '1',
                Unit: '',
                CodeRepeat: false,
                State: 0,
                PackedCount: 0,
                IsPacked: false
            });

            // 当dataList数量大于50时
            if (this.dataList.length > 50) {
                this.startIdx += 1;
                this.endIdx += 1;
            }

            this.priceChange();
        },
        // 搜索汽配编码
        searchCode(key) {
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeList = [];
            }
            if (this.codeForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSetOrder',
                    data: {
                        APCode: this.codeForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data) return;
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            this.codeForm.Page += 1;
            this.searchCode();
        },
        // 搜索名称
        searchName(key) {
            if (![undefined].includes(key)) {
                this.nameForm.Page = 1;
                this.nameForm.stopLoad = false;
                this.nameForm.key = key;
                this.nameList = [];
            }
            if (this.nameForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSetOrder',
                    data: {
                        GoodName: this.nameForm.key,
                        Page: this.nameForm.Page,
                        Limit: this.nameForm.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data) return;
                    this.nameForm.stopLoad = res.data.length < this.nameForm.Limit;
                    this.nameList = this.$util.uniqueArr(this.nameList, res.data);
                });
        },
        // 汽配名称列表，加载更多
        searchNameLoad() {
            this.nameForm.Page += 1;
            this.searchName();
        },
        // 搜车系
        searchAutoSerie(key) {
            this.loading = true;
            this.$util.searchAutoSerie(key).then(data => {
                this.seriesList = data;
                this.loading = false;
            });
        },
        // 名称改变
        nameChange(value, index) {
            this.editIndex = index;
            let _list = this.nameList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].GoodName == value) {
                    if (!this.dataList[index].APCode) {
                        this.dataList[index].APCode = _list[i].APCode;
                        this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    }
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].SetId = _list[i].SetId;
                }
            }
            this.priceChange();
            this.checkCodeRepeat();
        },
        // 编码改变
        codeChange(value, index) {
            this.checkCodeRepeat();
            this.editIndex = index;
            let _list = this.codeList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].APCode == value) {
                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].SetId = _list[i].SetId;
                }
            }

            this.priceChange();
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
            }
            this.allNum = _allNum;
            this.dataList = DetailList;
        },
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        // 改变商品数量
        handleNumChange(data, value, index) {
            this.dataList[index].Count = value;
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.codeList.length == 0) that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.nameList.length == 0) that.searchName('');
            }
        },
        // //从缓存中获取默认出仓仓库
        // getdefaultWarehouses() {
        //     if (this.dataReadonly) return;
        //     let defaultWarehouses = this.$util.getLocalStorage('defaultSetOrderWarehouses');
        //     if (defaultWarehouses) {
        //         let defaultWareshouse = defaultWarehouses;
        //         if (defaultWareshouse) {
        //             this.warehouseList.push({
        //                 WarehouseId: defaultWareshouse.WarehouseId,
        //                 WarehouseName: defaultWareshouse.WarehouseName
        //             });
        //             this.$set(this.submitData, 'SId', defaultWareshouse.WarehouseId);
        //         }
        //     }
        // },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.warehouseName = '';
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.warehouseName = that.warehouseList[i].WarehouseName;
                        break;
                    }
                }
            }
        },
        closeSetPackDialog(refresh = false) {
            if (refresh) this.getSetOrderDetail();
            this.setPackVisible = false;
        },
        setPack(type, item) {
            this.pType = type;
            if (type == 1) {
                if (item.State != 0) {
                    this.$util.warningMsg('商品已删除');
                    return;
                }
                this.title = '单套包组装';
                this.setId = item.SetId;
                this.maxCount = item.Count - item.PackedCount;
            } else if (type == 2) {
                this.title = '查看套包商品';
                this.setId = item.SetId;
            } else {
                let _dataList = this.dataList;
                for (let i = 0; i < _dataList.length; i++) {
                    if (_dataList[i].State != 0) {
                        this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                        return;
                    }
                }
                this.title = '整单组装';
            }
            this.setPackVisible = true;
        }
    }
};
</script>
<style lang="less" scoped>
.el-form-item {
    margin-bottom: 0px;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}
.option-content {
    display: flex;
    line-height: 30px;
}
.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
</style>
<style lang="less">
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}

.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 20px;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>
